var _circle, _path, _path2, _path3, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBusinessOrange = function SvgBusinessOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 23,
    r: 19,
    fill: "url(#business-orange_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#business-orange_svg__b)",
    d: "M15.772 55.37A16 16 0 0 1 31.554 42h16.892a16 16 0 0 1 15.782 13.37l1.337 8.018c.29 1.738.435 3.498.435 5.26V72H14v-3.352c0-1.762.146-3.522.435-5.26l1.337-8.018Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M35 46.5V63a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V46.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M58 51h13.681a2 2 0 0 0 1.838-1.212l2.32-5.41A2 2 0 0 0 76 43.59V37a2 2 0 0 0-2-2H36a2 2 0 0 0-2 2v6.59a2 2 0 0 0 .162.787l2.319 5.41A2 2 0 0 0 38.319 51H52M47 35v-2a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    x: 52,
    y: 49,
    stroke: "#000",
    rx: 1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "business-orange_svg__a",
    x1: 59.464,
    x2: 20.98,
    y1: 22.413,
    y2: 22.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "business-orange_svg__b",
    x1: 66.635,
    x2: 13.973,
    y1: 56.536,
    y2: 56.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })))));
};
export default SvgBusinessOrange;